export default "__VITE_ASSET__D13gi4x$__"